// extracted by mini-css-extract-plugin
export var active = "_gc-7";
export var blink = "_gc-8";
export var dropDownSelector = "_gc-4";
export var dropDownWrapper = "_gc-3";
export var fakeCursor = "_gc-6";
export var fontSizeButton = "_gc-9";
export var formQuillEditor = "_gc-0";
export var pressed = "_gc-a";
export var qlBlank = "_gc-1";
export var textFormattingToolbar = "_gc-2";
export var textToolbarOption = "_gc-5";